import { Action } from '@ngrx/store';
import { Disposition } from './disposition.model';

export const LIST = '[Disposition] List';
export const LIST_COMPLETE = '[Disposition] List Complete';
export const LIST_FAILED = '[Disposition] List Failed';

export const DELETE = '[Disposition] Delete';
export const DELETE_COMPLETE = '[Disposition] Delete Complete';
export const DELETE_FAILED = '[Disposition] Delete Failed';

export const ADD = '[Disposition] Add';
export const ADD_COMPLETE = '[Disposition] Add Complete';
export const ADD_FAILED = '[Disposition] Add Failed';

export const UPDATE = '[Disposition] Update';
export const UPDATE_COMPLETE = '[Disposition] Update Complete';
export const UPDATE_FAILED = '[Disposition] Update Failed';


export class ListAction implements Action {
    readonly type = LIST;

    constructor(public payload: number) { }
}

export class ListCompleteAction implements Action {
    readonly type = LIST_COMPLETE;
    constructor(public payload: Disposition[]) { }
}

export class ListFailedAction implements Action {
    readonly type = LIST_FAILED;

    constructor(public payload: { error: any }) { }
}

export class DeleteAction implements Action {
    readonly type = DELETE;

    constructor(public payload: number) { }
}

export class DeleteCompleteAction implements Action {
    readonly type = DELETE_COMPLETE;

    constructor(public payload: number) { }
}

export class DeleteFailedAction implements Action {
    readonly type = DELETE_FAILED;

    constructor(public payload: { error: any }) { }
}

export class AddAction implements Action {
    readonly type = ADD;

    constructor(public payload: any) { }
}

export class AddCompleteAction implements Action {
    readonly type = ADD_COMPLETE;

    constructor(public payload: any) { }
}

export class AddFailedAction implements Action {
    readonly type = ADD_FAILED;

    constructor(public payload: { error: any }) { }
}

export class UpdateAction implements Action {
    readonly type = UPDATE;

    constructor(public payload: any) { }
}

export class UpdateCompleteAction implements Action {
    readonly type = UPDATE_COMPLETE;

    constructor(public payload: any) { }
}

export class UpdateFailedAction implements Action {
    readonly type = UPDATE_FAILED;

    constructor(public payload: { error: any }) { }
}

export type Actions
    = ListAction
    | ListCompleteAction
    | ListFailedAction
    | AddAction
    | AddCompleteAction
    | AddFailedAction
    | UpdateAction
    | UpdateCompleteAction
    | UpdateFailedAction
    | DeleteAction
    | DeleteCompleteAction
    | DeleteFailedAction
